import * as React from "react";
import { NavLink } from "react-router-dom";
import { NavigationLink } from "types";
import * as styles from "./styles";

interface IProps {
  links: NavigationLink[];
}

const Tabs: React.FunctionComponent<IProps> = ({ links }) => (
  <div className={styles.tabs}>
    <div className={styles.tabGroup}>
      {links
        .filter(link => link.position === "left")
        .map(link => (
          <NavLink
            key={link.to}
            exact={link.exactMatch}
            isActive={(match, location) => {
              if (match) {
                return true;
              }

              return (
                link.to === "/" && links.filter(it=> it.to === location.pathname).length===0
              );
            }}
            className={styles.link}
            activeClassName={styles.active}
            to={link.to}
          >
            {link.text}
          </NavLink>
        ))}
    </div>
    <div>
      {links
        .filter(link => link.position === "right")
        .map(link => (
          <NavLink
            key={link.to}
            exact={link.exactMatch}
            className={styles.link}
            activeClassName={styles.active}
            to={link.to}
          >
            {link.text}
          </NavLink>
        ))}
    </div>
  </div>
);

export default Tabs;
